import React, 
       { useContext,
         useEffect,
         useState } from 'react';
import { Redirect,
         withRouter } from 'react-router-dom';
import { Container,
         TextField,
         Fab,
         IconButton,
         Grid,
         Fade,
         CircularProgress,
         Link,
         Button, 
         Typography} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGoogle, 
         faYahoo,
         faFacebookF } from '@fortawesome/free-brands-svg-icons';  //icons: https://fontawesome.com/icons
import { FaAxosLogo,
         FaSportsEngineLogo,
         FaTeamsnapLogo,
        } from '../assets/Icons'; 
import { faBomb,
         faEye,
         faMask,
         faEyeSlash,
         faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { GATag, Stack } from "../util/tools";
import { loadImage } from "../util/util";
import { INFO, CONSTS } from "../util/object";
import { appContext } from "./index";
//import { firebaseAuth } from "../util/constants";
import firebase from 'firebase/app';
import { AuthClass,
         onSignin,
         checkAuthResponse } from '../class/AuthClass';

var auth = new AuthClass();
const login_useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        maxHeight: '80vh',
        minHeight: '80vh',
        alignSelf: 'center',
        //justifyContent: 'flex-start',
        //overflow: 'auto',    // enable scroll
        //backgroundColor:'#eeeeee',
    },
    spacer: {
        height: '0vh',
        //backgroundColor:'#ff00dd',
    },
    icon_tray: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        padding: '0',
        //backgroundColor:'#dddddd',
    },
    icon: {
        marginLeft: '2.5vh',
        marginRight: '2.5vh',
        minWidth: '7vh',
        minHeight: '7vh',
        justifyContent: 'flex-start',
        //backgroundColor:'#dddd88',
    },
    box_icon: {
        borderColor: 'rgba(255,255,255,0)',
        borderRadius: '15px',
        border: '0px',
        boxShadow: '0 10 20 0',
        //marginLeft: '2.5vh',
        //marginRight: '2.5vh',
        //paddingLeft: '2vh',
        //paddingRight: '1vh',
        paddingLeft: '0',
        paddingRight: '0',
        marginTop: '0.6vh',
        marginBottom: '0.7vh',
        marginLeft: 'auto',
        marginRight: 'auto',
        width: '30vw',
        //minWidth: '280px',
        minWidth: '230px',
        height: '7vh',
        minHeight: '60px',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        //minWidth: '200px',
        backgroundColor: 'rgba(43, 65, 120, 0.95)',     // Dark Cornflower Blue
    },
    anon_box_icon: {
        backgroundColor:'#737e96',
        display: "none",
    },
    logo_icon: {
        //marginRight: '2vw',
        //width: "15%",       // 20%
        //minWidth: '5vw',   // 10vw
        //minHeight: '3vh',
        width: "50%",
        alignSelf: "flex-start",
        //backgroundColor:'#dddd88',
    },
    logo_text: {
        marginLeft: '1vh',
        //marginRight: '2vh',
        fontSize: '1.2rem',     // 1.5
        textAlign: 'start',
    },
    grid_row: {
        alignContent: "center",
    },
    grid_text: {
        //alignSelf: "flex-start",
        alignSelf: "center",
    },
    eye_icon: {
        //marginLeft: '2.5vh',
        //marginRight: '2.5vh',
        minWidth: '3vh',
        minHeight: '3vh',
        alignSelf: 'flex-end',
        marginBottom: '10px',
        //backgroundColor:'#dddd88',
    },
    line: {
        display: 'flex',
        alignSelf: 'center',
        width: '30vh',
        //backgroundColor:'#ffeedd',
    },
    login: {
        display: 'flex',
        flex: 0.9,
        flexDirection: 'column',
        //justifyContent: 'center',
        alignItems: 'center',   // does vertical
        marginTop: '1vh',
        width: '70%',
        //backgroundColor:'#ffeeff',
    },
    error_message: {
        alignItems: 'center',
    },
    textField: {
        flex: 0.98,
        width: '100%',
        flexDirection: 'column',
        marginTop: '2vh',
        marginBottom: '1vh',
        //alignItems: 'center',
        //padding: '1vh',
        //flexDirection: 'row',
        //backgroundColor:'#ffffff',
    },
    button: {
        display: 'flex',
        alignSelf: 'center',
        marginTop: '0vh',
        //width: '100%',
        //backgroundColor:'#ffeedd',
    },
    progress: {
        marginTop: '2vh',
        marginBottom: '2vh',
        alignSelf: 'center',
        //backgroundColor:'#ff88ff',
    },
    link: {
        marginTop: '4vh',
        //backgroundColor:'#ff88ff',
    },
    hidden: {
        display: "none",
    }
}))


const Login = (props) => {
    var has_login;
    var timeout;
    const classes = login_useStyles();
    const [ Login_State, setLogin ] = useState({email: '', password: '', show: false, loginMessage: ''})
    const [ ShowPassword, setShowPassword ] = useState(false);
    const [ Timeout, setTimeOut ] = useState(null);

    const { State, Dispatch } = useContext(appContext);
    function setState(name, value) {
        //console.log("setState.login:  ",name," =", value, " @", Stack(new Error().stack));
        Dispatch({ type: [name], value: value });  // reducer wrapper
    }
    

    useEffect(() => {
        //setState('show_login', false);    // do no show email login by default
        //loadIcons();
        //checkAuthResponse(State, setState, "login.200");

        if (auth.loggedIn() == true) {
            var cookie_uid = auth.getCookie(CONSTS.COOKIE_FB_UID); 
            var cookie_email = auth.getCookie(CONSTS.COOKIE_EMAIL); 

            setState('authed', true);
            setState("show_progress", true);
            setState('has_login',  auth.getCookie(CONSTS.COOKIE_HAS_LOGIN)); 
            setState('uid', cookie_uid);      // use logged in id for firestore
            setState('email', cookie_email);      // use logged in id for firestore
            setState('photo', auth.getCookie(CONSTS.COOKIE_AVATAR));      // use logged in id for firestore
            //setState('has_login', localStorage.getItem('has_login'));
            //setState('photo', auth.getAvatar());      // use logged in id for firestore

            INFO.show_login_progress = true;
            INFO.uid = cookie_uid;      // use logged in id for firestore
            INFO.email = cookie_email;      // use logged in id for firestore
            console.log("auth.197:  USER ALREADY LOGIN");
        } else {
            INFO.show_login_progress = false;
            setState("show_progress", false);
        }
    }, [1]);

     
    useEffect(() => {
        //setState("show_progress", false);
        //console.log("useEffect: State.show_welcome changed! "+State.show_welcome);
        //setState('show_welcome', false);
    //}, [State.show_welcome, State.registration, State.refresh_display, State.splash_done]);
    }, [State.refresh_display, State.splash_done, State.show_progress]);
    
    // process input event and write into local State.object
    const inputLogin = name => event => {
        setState([name], event.target.value)
    }

    // function call to merge into local State.object
    function setLoginState (name, value) {
        console.log("setLoginState: name="+name+"  value="+value);
        setLogin(prev=>({ ...prev.Login_State, [name]: value}));
    }

    function showLogin() {
        if (State.show_login)
            setState('show_login', false);
        else
            setState('show_login', true);
    }


    /*
    async function loadIcons() {
        const se_icon_path = "../assets/images/sports_engine_icon.png"
        const ts_icon_path = "../assets/images/teamsnap_icon.png"
        //const SE_icon = await loadImage(se_icon_path);
        //const TS_icon = await loadImage(ts_icon_path);
        setTSIcon(ts_icon_path);
        setSEIcon(se_icon_path);
    }
    */


    const handleRegister = e => {
        e.preventDefault();

        console.log("****** handleRegister: "+State.login+" "+State.password)
        auth.firebase_auth(State.login, State.password)
        .then(() => {
            setState('authed', true);
            setState("show_progress", false);
        })
        .catch(error => {
            console.log("handleRegister: error ", error)
            setState('loginMessage', error.message);
            setState('show_login', true);
        });
    };


    // use fixed email to fake anon loging, force timeout after one session
    //
    const handleAnonymous = e => {
        console.log("****** handleAnonLogin: auth=", auth, " State=", State);
        auth.login_email("anon@ldoit.com", "for1session!")
        .then(res => {
            console.log("handleLogin.246: ANON LOGIN SUCCESS!  ", res)
            INFO.anon_mode = true;
            postLogin(res.user);
            checkAuthResponse(State, setState, "login.286.anon");
        })
        .catch(error => {
            console.log("handleLogin.ERROR: ", error)
            setState('loginMessage', error.message);
            //throw(error);
        });
        

    }



    const postLogin = (user) => {
        var curr = firebase.auth().currentUser;
        console.log("post_login.280: current user =", curr);
        //setState("show_progress", false);
        if ((user !== undefined) && (user !== null)) {
            setState("authed", true);
            //setState("user_id", user.email);
            INFO.email =  user.email;
            INFO.uid =  user.uid;

            console.log("login.275:  email=",user.email);
        } else {
            GATag("Onboarding", "Login.GoogleSignInClick", "FAILED", 0);		 // (cat, act, lab, val)
        }


    }

    const handleLogin = login_type => e => {

        if ((auth === null) || (auth === undefined)) {
            return;     // config issue
        }
        setState('show_progress', true); 
        switch (login_type) {
            case "google":
                console.log("login.328:          START GOOGLE LOGIN....");
                GATag("Onboarding", "Register.GoogleSignInClick", "", 0);		 // (cat, act, lab, val)
                auth.login_google()
                .then(googleUser => {
                    console.log("login.270: ############# SUCCESS  google return status=",googleUser);
                    postLogin(googleUser);
                    setState("authed", true);
                    setState("show_progress", true);

                    checkAuthResponse(State, setState, "login.334.google");
                    //onSignin(googleUser, State, setState, "login.334.google");
                })
                .catch(function(error) {
                    console.error("goog_auth.279: login ERROR ",error);
                    setState("show_progress", false);
                    INFO.show_login_progress = false;
                    return null;
                });

                break;

            case "facebook":
                GATag("Onboarding", "Register.FacebookSignInClick", "", 0);		 // (cat, act, lab, val)
                auth.login_facebook()
                .then(user => {
                    console.log("login.282:  facebook return status=",user);
                    if (user !== undefined) {
                        setState("authed", true);
                        setState("show_progress", false);
                        //INFO.show_login_progress = false;
                        checkAuthResponse(State, setState, "login.354.fb");
                    } else {
                        GATag("Onboarding", "Register.GoogleSignInClick", "FAILED", 0);		 // (cat, act, lab, val)
                    }
                })
                checkAuthResponse(State, setState, "login.359.facebook");
                break;

            case "yahoo":
                GATag("Onboarding", "Register.YahooSignInClick", "", 0);		 // (cat, act, lab, val)
                auth.login_yahoo()
                .then(user => {
                    console.log("login.293:  yahoo return status=",user);
                    if (user !== undefined) {
                        setState("authed", true);
                        setState("show_progress", false);
                        INFO.show_login_progress = false;
                    }
                })
                checkAuthResponse(State, setState, "login.373.yahoo");
                break;

            case "email":
                GATag("Onboarding", "Register.UseEmailToRegisterClick", "", 0);		 // (cat, act, lab, val)
                console.log("****** handleLogin: "+State.login+" "+State.password);
                if((auth !== null) && (auth.login_email !== null) && (State.login !== null)) {
                    console.log("****** handleLogin: auth=", auth, " State=", State);
                    auth.login_email(State.login, State.password)
                    .then(error => {
                        console.log("handleLogin.OK: ", error)
                        //setState('loginMessage', error.message);
                    })
                    .catch(error => {
                        console.log("handleLogin.ERROR: ", error)
                        setState('loginMessage', error.message);
                        //throw(error);
                    });
                    checkAuthResponse(State, setState, "login.391.email");
                }
                break;
        }

        setTimeout( checkAuthResponse.bind(this, State, setState, "delay.login.396"),  // special binding of param
                    CONSTS.REALTIME_CHECK_INTERVAL);

/*
        // catch result from the redirect
        firebase.auth().getRedirectResult().then((result) => {
            console.log("login.399: ************** RECIVING REDIRECT RESULT: result=", result);
            if (result.credential) {
                var token = result.credential.accessToken;
            }

            var user = result.user;    // The signed-in user info.
            checkAuthResponse.bind(this, State, setState, "redirect.407");  // special binding of param

        }).catch(function(error) {
            var errorCode = error.code;
            var errorMessage = error.message;
            var email = error.email;
            var credential = error.credential;
            if (errorCode === 'auth/account-exists-with-different-credential') {
                alert('You have already signed up with a different auth provider for that email.');
                // If you are using multiple auth providers on your app you should handle linking
                // the user's accounts here.
            } else {
                console.error(error);
            }
        });
*/

    };

    const handleShowPassword = e => {
        GATag("Onboarding", "Register.ShowPasswordClick", ShowPassword, 0);		 // (cat, act, lab, val)
        setShowPassword(ShowPassword ? false : true);
        setState('refresh_display', ++State.refresh_display);
    }

    const setHasLogin = e => {
        GATag("Onboarding", "Register.IHaveAccountClick", has_login, 0);		 // (cat, act, lab, val)
        has_login = (State.has_login) ? false : true;
        //localStorage.setItem('has_login', has_login);
        auth.setCookie(CONSTS.COOKIE_HAS_LOGIN, has_login);     // USED?
        setState('has_login', has_login);           // USED?
        setState('registration', !has_login);       // USED?

        console.log("toggleLogin: set has_login to "+has_login);
    }

    const resetPassword = () => {
        auth.resetPassword(Login_State.email)
          .then(() => {
              setState('loginMessage', `Password reset email sent to ${Login_State.email}.`)
          })
          .catch(error => setState('loginMessage', `Email address not found.`));
    };

    function setErrorMsg(error) {
        return {
            type: 'loginMessage', value: error
        };
    }

    // OBSOLETE: test to get twillion #, can't embed in onClick()!
    function getAvailNumbers() {
        setState('show_numbers', true);
    }
    

    /*
    const renderRedirect = () => {
        if(State.show_redirect === true) {
            GATag("menu", "/splash", "jump");  // (cat, act, lab, val)
            console.log("#################### login.renderRedirect:   /splash ");
            return <Redirect to="/splash" />
        }
    }
    */



    return (
        <div id="quickstart-sign-in" className={classes.root}>

            <React.Fragment>
            <div className={classes.spacer} />
             {INFO.show_login_progress && <div className={classes.progress}>
                <Fade   in={(State.show_progress || INFO.show_login_progress)}
                        style={{ transitionDelay: (State.show_progress || INFO.show_login_progress) ? '30ms' : '0ms', }}
                        unmountOnExit >
                    <CircularProgress />
                </Fade>
            </div>}
            <Container className={classes.icon_tray} >
                {/*<Button size="small" onClick={login_google} color="primary" className={classes.icon} >*/}
                <Button color="primary" 
                        variant="contained" 
                        onClick={handleLogin("google")}
                        aria-label="Google" 
                        className={classes.fab+" "+classes.box_icon} >
                    <Grid container className={classes.grid_row}>
                        <Grid item xs={3}>
                            <FontAwesomeIcon 
                                className={classes.logo_icon}
                                icon={faGoogle} 
                                style={{width: '40%', fontSize: '1.7rem'}} />
                        </Grid>
                        <Grid item xs={9} className={classes.grid_text}>
                            <Typography className={classes.logo_text}>
                                GOOGLE
                            </Typography>
                        </Grid>
                    </Grid>
                </Button>

                <Button color="primary" 
                        disabled={false}
                        variant="contained" 
                        onClick={handleLogin("facebook")}
                        aria-label="Facebook" 
                        className={classes.fab+" "+classes.box_icon} >
                    <Grid container className={classes.grid_row}>
                        <Grid item xs={3}>
                            <FontAwesomeIcon 
                                className={classes.logo_icon}
                                icon={faFacebookF} 
                                style={{width: '40%', fontSize: '1.7rem'}} />
                        </Grid>
                        <Grid item xs={9} className={classes.grid_text}>
                            <Typography className={classes.logo_text}>
                                FACEBOOK
                            </Typography>
                        </Grid>
                    </Grid>
                </Button>

                <Button color="primary" 
                        disabled={true}
                        variant="contained" 
                        onClick={handleLogin("teamsnap")}
                        aria-label="Facebook" 
                        className={classes.fab+" "+classes.box_icon} >
                    <Grid container className={classes.grid_row}>
                        <Grid item xs={3}>

                            <FaTeamsnapLogo className={classes.logo_icon} 
                                style={{width: '50%'}} />
                            {/*<img src={require("../assets/images/teamsnap_icon.png")}
                                alt="Teamsnap"
                                className={classes.logo_icon} />*/}
                        </Grid>
                        <Grid item xs={9} className={classes.grid_text}>
                            <Typography className={classes.logo_text}>
                                TEAMSNAP
                            </Typography>
                        </Grid>
                    </Grid>
                </Button>

                 <Button color="primary" 
                        disabled={true}
                        variant="contained" 
                        onClick={handleLogin("sportengine")}
                        aria-label="Sports Engine" 
                        className={classes.fab+" "+classes.box_icon} >
                    <Grid container className={classes.grid_row}>
                        <Grid item xs={3}>
                            <FaSportsEngineLogo className={classes.logo_icon}
                                style={{width: '60%'}} />
                            {/*<img src={require("../assets/images/sports_engine_icon.png")}
                                alt="sports engine"
                                className={classes.logo_icon} />*/}
                        </Grid>
                        <Grid item xs={9} className={classes.grid_text}>
                            <Typography className={classes.logo_text}>
                                SPORTS ENGINE
                            </Typography>
                        </Grid>
                    </Grid>
                </Button>

                 {/*<Button color="primary" 
                        variant="contained" 
                        onClick={handleAnonymous}
                        aria-label="Anonymous" 
                        className={classes.fab+" "+classes.box_icon+" "+classes.box_icon} >
                    <Grid container className={classes.grid_row}>
                        <Grid item xs={3}>
                        <FontAwesomeIcon 
                                className={classes.logo_icon}
                                icon={faMask} 
                                style={{width: '50%'}}
                                size="3x" />
                        </Grid>
                        <Grid item xs={9} className={classes.grid_text}>
                            <Typography className={classes.logo_text}>
                                JUST CURIOUS
                            </Typography>
                        </Grid>
                    </Grid>
                </Button>*/}
            </Container >

            {/*<Button size="large"                              
                    onClick={showLogin} 
                    className={classes.button}
                    color="primary">
                OR USE EMAIL TO {(State.has_login) ? "SIGN IN" : "REGISTER"}
            </Button>

      
            {/*<Container className={(State.show_login) ? classes.login : classes.hidden} >
                  <Grid container className={classes.line}> 
                      <TextField
                        required
                        autoComplete="false" 
                        id="standard-phone"
                        className={classes.textField}
                        label="Email"
                        value={State.login}
                        onChange={inputLogin('login')} />
                      <div className={classes.eye_icon} />
                  </Grid>
                  <Grid container className={classes.line}> 
                        <TextField
                                required
                                autoComplete="false"
                                className={classes.textField}
                                type={(ShowPassword)? "text" : "password"}
                                label="Password"
                                onChange={inputLogin('password')} />
                        <IconButton color="primary" 
                                aria-label="show" 
                                size="small"
                                onClick={handleShowPassword}
                                className={classes.eye_icon} >
                            <FontAwesomeIcon 
                                    icon={(ShowPassword) ? faEyeSlash : faEye} 
                                    size="1x" />
                        </IconButton>
                  </Grid>
        
                 <Button color="primary" 
                        disabled={true}
                        variant="contained" 
                        onClick={handleLogin("yahoo")}
                        aria-label="Yahoo" 
                        className={classes.fab+" "+classes.box_icon} >
                   <FontAwesomeIcon 
                        className={classes.logo_icon}
                        icon={faYahoo} 
                        size="3x" />
                    <Typography className={classes.logo_text}>
                        YAHOO
                    </Typography>
                </Button>

                  <br />
                  {State.loginMessage && (
                      <div className="alert alert-danger" role="alert">
                          <div className="error_message">
                              <span
                                className="glyphicon glyphicon-exclamation-sign"
                                aria-hidden="true" />
                              <span className="sr-only">Error:</span>
                              &nbsp;{State.loginMessage}{' '}
                          </div>
                      </div>
                  )}

                  <Button className={classes.button}
                        variant="contained" 
                        onClick={(State.has_login) ? handleLogin("email") : handleRegister}
                        color="primary">
                      {(State.has_login) ? "SIGN IN" : "REGISTER"}
                  </Button>

                  <Link component="button"
                        className={classes.link}
                        variant="body2"
                        value={false}
                        onClick={setHasLogin}>

                      {(State.has_login) ? "REGISTER NEW ACCOUNT" : "I HAVE AN ACCOUNT"}
                  </Link>
                </Container>*/}

                {/*  renderRedirect() */}
            </React.Fragment>

        </div>
    );
}



export default withRouter(Login);